import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';

import { ServiceUnit } from '@shared/models';

import { BaseService } from '../base.service';
import { httpParams } from '../http-params.builder';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class ServiceUnitService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  getAll(loader: string, weeks?: string[]): Observable<ServiceUnit[]> {
    this.loadersService.show(loader);
    const url = `${this.baseUrl}/service-units`;
    return this.http
      .get<ServiceUnit[]>(url, { params: httpParams().array('weeks', weeks).build() })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getByUser(loader: string, userId: string): Observable<ServiceUnit[]> {
    this.loadersService.show(loader);
    const url = `${this.baseUrl}/service-units/user/${userId}`;
    return this.http.get<ServiceUnit[]>(url).pipe(finalize(() => this.loadersService.hide(loader)));
  }

  edit(
    loader: string,
    serviceUnits: ServiceUnit[],
    assignedEmployeesToRemove: { id: string; projectId: string; week: string; userId: string }[],
    weeks?: string[]
  ): Observable<ServiceUnit[]> {
    this.loadersService.show(loader);
    return this.http
      .put<
        ServiceUnit[]
      >(this.baseUrl + '/service-units', { serviceUnits: serviceUnits, assignedEmployeesToRemove: assignedEmployeesToRemove }, { params: httpParams().array('weeks', weeks).build() })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }
}
